import { useCallback, useMemo } from "react";
import { useQuery } from "react-query";

import { getOffers, SOURCE_VIDAPP, SUPPORTED_OFFER_DURATIONS } from "@/api";
import { useAppProperties } from "@/hooks";

export const useOffers = () => {
  const { data: properties } = useAppProperties();
  const query = useQuery(["offers"], () => {
    return getOffers();
  });

  const forSaleOffers = useMemo(() => {
    if (!query.data) {
      return undefined;
    }
    return query.data.filter(
      ({ ReadyForSaleWeb, SubscriptionDuration, WebPriceUSD, DataSource }) => {
        const isFreeOffer = WebPriceUSD === 0 && DataSource === SOURCE_VIDAPP;

        // Free access apps should only have free offers
        if (properties?.FreeAccessApp === "1" && !isFreeOffer) {
          return false;
        }

        return (
          ReadyForSaleWeb === "yes" &&
          (SUPPORTED_OFFER_DURATIONS.includes(SubscriptionDuration) ||
            isFreeOffer)
        );
      },
    );
  }, [query.data, properties?.FreeAccessApp]);

  const getOfferBySourceProductId = useCallback(
    (sourceProductId: string) => {
      if (!query.data) {
        return undefined;
      }
      return query.data.find(
        (offer) => offer.SourceProductId === sourceProductId,
      );
    },
    [query.data],
  );

  const getOfferByPriceId = useCallback(
    (priceId: string) => {
      if (!query.data) {
        return undefined;
      }
      return query.data.find((offer) => offer.ProductIdWeb === priceId);
    },
    [query.data],
  );

  return {
    forSaleOffers,
    getOfferBySourceProductId,
    getOfferByPriceId,
    ...query,
  };
};
